export default "__VITE_ASSET__Bujnniib__"